<template>
  <div class="home">
    <div class="container">
    <img alt="Offline logo" src="../assets/offline.png">
    </div>
  </div>
</template>

<script>

export default {
  name: 'offlinePage',
  components: {

  },
  data(){
    return{
      code: '',
    }
  },
  mounted(){

  },
  methods: {

  }
}
</script>

<style scoped>

.container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.box {
  height: 100px;
  width: 200px;
  background: #fff;
  padding: 50px;
  border-radius: 10px;
  position: relative;
  text-align: center;
}

</style>
